export { default } from './LabItem';
